import { http } from "./config";
import authHeader from "./auth-header";

export default {
  salvar: (payload) => {
    return http.post("/blacklist/salvar", payload, {
      headers: authHeader(),
    });
  },
  ultimos: () => {
    return http.get("/blacklist/ultimos", {
      headers: authHeader(),
    });
  },
  buscarPorCliente: (idCliente) => {
    return http.get("/blacklist/cliente", {
      params: { idCliente },
      headers: authHeader(),
    });
  },
  buscarPorTipoValor: (tipo, valor) => {
    return http.get("/blacklist/buscar", {
      params: { tipo, valor },
      headers: authHeader(),
    });
  },
  alterarStatus: (id, ativo) => {
    return http.put(
      "/blacklist/alterar-status",
      { id, ativo },
      {
        headers: authHeader(),
      }
    );
  },
};
